import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EntData, SimpleData } from '@bazis/shared/models/srv.types';
import { TemplateObservable } from '@bazis/shared/classes/template-observable';
import { BazisEntityService } from '@bazis/shared/services/entity.service';

@UntilDestroy()
@Component({
    selector: 'bazis-browse-options',
    templateUrl: './browse-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisBrowseOptionsComponent implements OnInit {
    @HostBinding('class.bazis-browse-default') get getHostClass() {
        return true;
    }

    @Input()
    titleKey;

    @Input()
    titleParams;

    @Input()
    value;

    @Input()
    unitKey;

    @Input()
    options: EntData[] | SimpleData[] = null;

    @Input()
    entityType: string = null;

    values: TemplateObservable<string[]> = new TemplateObservable<string[]>([]);

    optionsMap = null;

    constructor(protected entityService: BazisEntityService) {}

    ngOnInit() {
        this.values.set(Array.isArray(this.value) ? this.value : [this.value]);
        if (this.options) {
            this.optionsMap = {};
            this.options.forEach((v) => {
                this.optionsMap[v.id] = v;
            });
        }
    }
}
